import React from 'react';
import IntegrationDocTemplate from '../../../../components/IntegrationDocTemplate';

export default function Docs3PLOnboarding() {
  return (
    <IntegrationDocTemplate
      title="Onboarding Your Own 3PL"
      category="Warehousing · For 3PL Providers"
      status="live"
      summary="Are you a 3PL? Sign up as a provider on our marketplace. Sellers post RFQs, your three_pl_partnership agent auto-drafts bids, you compete on cost × speed × reputation. Once contracted, the integration is standardized — one API for inventory, allocation, manifests, POD."
      prerequisites={[
        'Operating 3PL with US warehouse(s).',
        'Decision-maker willing to commit ~2-3 weeks for full operational integration.',
        'API capability or willingness to use our standardized operational endpoints.',
      ]}
      connectSteps={[
        'Visit /3pl/onboard and create your provider profile.',
        'List capabilities (B2C parcel, B2B pallet, freight, cold-chain, hazmat, etc.) + certifications (SOC 2, FDA, AIB) + locations + monthly capacity.',
        'Configure your service catalog: per-unit pick fees, storage tiers, accessorials.',
        'Your three_pl_partnership agent starts receiving matching RFQs and auto-drafting bids based on your capacity/capability.',
        'When a seller accepts your bid, contract auto-generates → both sign via DocuSign → Stripe escrow → operational integration goes live.',
      ]}
      syncedData={[
        { type: 'Inventory levels', detail: 'You push to our /api/v2/3pl/inventory endpoint (real-time webhook or 15-min poll)' },
        { type: 'Pick tickets', detail: 'We push orders to your operational endpoint (we provide a reference webhook spec)' },
        { type: 'Manifests', detail: 'You push daily manifests via /api/v2/3pl/manifests' },
        { type: 'POD', detail: 'You push proof of delivery via /api/v2/3pl/pod with signature/photo URLs' },
        { type: 'Performance metrics', detail: 'Daily SLA stats roll up into your public reputation page at commerceindex.ai/3pl/{your-slug}' },
      ]}
      agents={[
        { id: 'three_pl_partnership', name: 'three_pl_partnership', role: 'Your provider-side agent that drafts bids on matching RFQs' },
        { id: 'three_pl_compliance_agent', name: 'three_pl_compliance_agent', role: 'Monitors your SLA performance daily, alerts on violations' },
      ]}
      troubleshooting={[
        { question: 'My bids never win', answer: 'Reputation has a 40% weight in the rank score. Build it by accepting smaller initial deals and delivering — first 30 days of clean SLA gets you promoted to TRUSTED tier.' },
        { question: 'Capacity constraints', answer: 'Update monthly_capacity_orders + current_utilization_pct in your profile. Our matching engine respects these.' },
      ]}
      supportLink="/contact"
    />
  );
}
